import React, { useState } from "react";
import { useRegistrationForm } from "../core/RegistrationFormProvider";
import Button from "../../Button";
import logo from "../../../storage/logo.png";

export default function SelectKidsTab() {
	const { registerData, setRegisterData } = useRegistrationForm();
	const { childs = [], parent_name, step } = registerData || {};
	const [selectedChildren, setSelectedChildren] = useState([]);
	const [error, setError] = useState("");

	const toggleChild = (child) => {
		setError("");
		setSelectedChildren((prev) => {
			const exists = prev.some((c) => c.child_name === child.child_name);
			if (exists) return prev.filter((c) => c.child_name !== child.child_name);
			return [...prev, child];
		});
	};

	const handleContinue = () => {
		if (selectedChildren.length === 0) {
			setError("יש לבחור לפחות ילד/ה אחד להרשמה");
			return;
		}
		setRegisterData({
			...registerData,
			selectedKids: selectedChildren,
			step: 2,
		});
	};

	return (
		<div
			className="min-h-screen w-full bg-cover bg-center"
			style={{ backgroundImage: "url(/keytana.jpg)", backgroundColor: "#1a1a2e" }}
		>
			<div className="min-h-screen w-full bg-white/30 backdrop-blur-sm">
				<div className="min-h-screen w-full flex items-center justify-center px-4 py-10">
					<div className="relative w-full max-w-xl rounded-3xl bg-white/95 text-black shadow-2xl px-8 py-10 text-center">
						<div className="absolute -top-12 left-1/2 -translate-x-1/2 w-24 h-24 rounded-full bg-white border-4 border-yellow-400 shadow-lg flex items-center justify-center">
							<img src={logo} alt="logo" className="w-16 h-16 object-contain" />
						</div>
						<strong className="text-3xl font-semibold mb-2 block">בחר ילד להרשמה</strong>
						{parent_name && (
							<p className="text-sm text-gray-600 mb-6">שלום {parent_name}, בחר את הילד/ה שברצונך לרשום</p>
						)}
						{!parent_name && (
							<p className="text-sm text-gray-600 mb-6">בחר את הילד/ה שברצונך לרשום לקייטנה</p>
						)}

						{childs.length === 0 ? (
							<p className="text-red-500 text-sm">לא נמצאו ילדים מקושרים לחשבון זה</p>
						) : (
							<div className="flex flex-col gap-3 mb-6">
								{childs.map((child, index) => {
									const isSelected = selectedChildren.some((c) => c.child_name === child.child_name);
									const isBooked = child.booked === 1 || child.booked === true || child.booked === "1";
									return (
										<button
											key={index}
											onClick={() => !isBooked && toggleChild(child)}
											disabled={isBooked}
											className={`w-full px-5 py-4 rounded-2xl text-right text-sm border-2 transition-all flex items-center gap-3
												${isBooked
													? "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed"
													: isSelected
														? "bg-yellow-50 border-yellow-400"
														: "bg-gray-100 border-transparent hover:border-yellow-300"
												}`}
										>
											<div className={`w-5 h-5 rounded border-2 flex-shrink-0 flex items-center justify-center transition-all
												${isBooked
													? "border-gray-300 bg-gray-200"
													: isSelected
														? "border-yellow-400 bg-yellow-400"
														: "border-gray-300 bg-white"
												}`}>
												{isSelected && (
													<svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
														<path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
													</svg>
												)}
											</div>
											<div className="flex-1">
												<span className="block font-semibold text-base">{child.child_name}</span>
												{isBooked && <span className="text-xs text-gray-400">כבר רשום/ה השנה</span>}
											</div>
										</button>
									);
								})}
							</div>
						)}

						{error && <p className="text-red-600 text-sm mb-4">{error}</p>}

						<div className="flex justify-between items-center">
							<Button
								onClick={() => setRegisterData({ ...registerData, step: undefined })}
							>
								חזור
							</Button>
							<Button
								onClick={handleContinue}
								disabled={childs.length === 0 || selectedChildren.length === 0}
							>
								המשך
							</Button>
						</div>

						<p className="text-xs text-gray-500 mt-6">אקשן על גלגלים — הקייטנה הכי כיפית</p>
					</div>
				</div>
			</div>
		</div>
	);
}
